import { render, staticRenderFns } from "./StatsUploadsView.vue?vue&type=template&id=1776d0a0&scoped=true"
import script from "./StatsUploadsView.vue?vue&type=script&lang=js"
export * from "./StatsUploadsView.vue?vue&type=script&lang=js"
import style0 from "./StatsUploadsView.vue?vue&type=style&index=0&id=1776d0a0&prod&scoped=true&lang=scss"
import style1 from "./StatsUploadsView.vue?vue&type=style&index=1&id=1776d0a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1776d0a0",
  null
  
)

export default component.exports